module.exports = __webpack_public_path__ + "static/media/Alex.d5372b42.jpg";